import React from 'react';
import WorkSpaceItem from '../WorkSpaceItem/WorkSpaceItem';

const WorkspaceList = ({ data, popoverMenuContent, setIsCollaspse }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {data?.map((item) => (
        <WorkSpaceItem
          key={item?.id}
          item={item}
          popoverMenuContent={popoverMenuContent}
          setIsCollaspse={setIsCollaspse}
        />
      ))}
    </div>
  );
};

export default WorkspaceList;
